module.exports = __webpack_public_path__ + "media/fonts/GintoNord-Medium-85c380039f5f613aaff384d31f138bd0.woff2";